import React from 'react';
import HeroSection from '../Sections/HeroSection';
import AboutSection from '../Sections/AboutSection';
import ProjectsSection from '../Sections/ProjectsSection';
import ExperienceSection from '../Sections/ExperienceSection';
import HelpSection from '../Sections/HelpSection';

const TerminalOutput = ({ item, currentSection }) => {
  const getTextColorClass = () => {
    switch (item.type) {
      case 'error':
        return 'text-terminal-red';
      case 'success':
        return 'text-terminal-green';
      case 'info':
        return 'text-terminal-blue';
      case 'warning':
        return 'text-terminal-yellow';
      case 'command':
        return 'text-terminal-dim';
      case 'section':
        return 'text-terminal-text';
      default:
        return 'text-terminal-text';
    }
  };

  const renderSectionContent = () => {
    switch (item.section) {
      case 'hero':
        return <HeroSection />;
      case 'about':
        return <AboutSection />;
      case 'skills':
        return (
          <div className="p-4 rounded-xl bg-white/5 border border-white/10 text-xs font-mono space-y-2">
            <div className="text-white font-bold">⚡ Core Technical Stack</div>
            <div className="text-zinc-300">• Languages: TypeScript, JavaScript, Python, Java, SQL</div>
            <div className="text-zinc-300">• Frontend: React.js, Next.js (App Router), Tailwind CSS</div>
            <div className="text-zinc-300">• Backend & APIs: Node.js, Express, FastAPI, RESTful APIs</div>
            <div className="text-zinc-300">• Databases & DevOps: PostgreSQL, MongoDB, Docker, Git, Vercel</div>
          </div>
        );
      case 'projects':
        return <ProjectsSection />;
      case 'experience':
        return <ExperienceSection />;
      case 'contact':
        return (
          <div className="p-4 rounded-xl bg-white/5 border border-white/10 text-xs font-mono space-y-2">
            <div className="text-white font-bold">📬 Direct Contact</div>
            <div className="text-zinc-300">• Email: <a href="mailto:sonishubh2004@gmail.com" className="text-white underline">sonishubh2004@gmail.com</a></div>
            <div className="text-zinc-300">• LinkedIn: <a href="https://linkedin.com/in/shubhsoni" target="_blank" rel="noreferrer" className="text-white underline">linkedin.com/in/shubhsoni</a></div>
            <div className="text-zinc-300">• GitHub: <a href="https://github.com/shubhhh19" target="_blank" rel="noreferrer" className="text-white underline">github.com/shubhhh19</a></div>
            <div className="text-zinc-300">• Location: Toronto, ON (Available for in-person & remote)</div>
          </div>
        );
      case 'help':
        return <HelpSection />;
      default:
        return null;
    }
  };

  if (item.section) {
    return (
      <div className="mb-4">
        {renderSectionContent()}
      </div>
    );
  }

  return (
    <div className={`mb-1 ${getTextColorClass()} leading-relaxed`}>
      {Array.isArray(item.content) ? (
        item.content.map((line, index) => (
          <div key={index} className="mb-1">
            {line}
          </div>
        ))
      ) : (
        <div>{item.content}</div>
      )}
    </div>
  );
};

export default TerminalOutput;